import React from 'react';
import './ButtonLoader.css';

interface ButtonLoaderProps {
  /** Size of the loader */
  size?: 'small' | 'medium' | 'large';
  /** Color theme - matches button colors */
  theme?: 'blue' | 'purple' | 'green';
  /** Custom class name */
  className?: string;
}

export const ButtonLoader: React.FC<ButtonLoaderProps> = ({
  size = 'small',
  theme = 'blue',
  className = ''
}) => {
  return (
    <div className={`button-loader ${size} ${theme} ${className}`}>
      <div className="button-loader-spinner">
        <div className="loader-ring outer-ring"></div>
        <div className="loader-ring inner-ring"></div>
        <div className="loader-dot"></div>
      </div>
    </div>
  );
};

export default ButtonLoader;

